module.exports = __webpack_public_path__ + "media/images/loading-e46d34673a4d1335d99396af0cc9ff43.gif";